import { render, staticRenderFns } from "./trap-manager.vue?vue&type=template&id=c42a26bc&scoped=true&"
import script from "./js/trap-manager.js?vue&type=script&lang=js&"
export * from "./js/trap-manager.js?vue&type=script&lang=js&"
import style0 from "./trap-manager.vue?vue&type=style&index=0&id=c42a26bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c42a26bc",
  null
  
)

export default component.exports